import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AI_gif1 from "../../../assets/Recruitment/AI_1.gif";
import AI_3 from "../../../assets/Recruitment/AI_3.png";
import AI_gif5 from "../../../assets/Recruitment/A1_5.gif";
import AI_4 from "../../../assets/Recruitment/AI_4.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function MechAccordion() {
  return (
    <div className="Accordian">
      <Accordion style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography>
              <h3>Mechanical</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="mech-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="orange text-center"
                    style={{ color: "#f49221" }}
                  >
                    Mechanical
                  </h1>
                  <p>
                    The challenges are divided into two parts, Mechanics and
                    Design. The challenges are meant to test your innovative
                    skills as well as your basics in Mechanical and Mathematics.
                  </p>

                  <h2 className="">
                    <strong>Mechanics</strong>
                  </h2>
                  <h4>
                    <b>
                      <u>EASY</u>
                    </b>
                  </h4>
                  <p>
                    It is late afternoon on the Student Plaza. Professor Heisenberg, a world-renowned
                    expert on drone engineering, checking out the delivery drone. Jesse another engineer is
                    stowing a 900 g payload into the cargo bay on a quadcopter. The mission is to fly from
                    Student Plaza to Block 16, an 800 m outbound trip and 800 m back, with a 50 m climb
                    on take-off and a 50 m descent on landing. Upon arriving over Block 16, the drone
                    deposits the payload and then begins the trip back.
                  </p>
                  
                    <p>
                     The total loaded mass on the drone is 5.0 kg, including the payload. It has a maximum
                        hover power capability of 120 W per propulsion unit, and the maximum power output
                        from its batteries is 750 W(k =0.58 for Phover). Its cruise speed is 12 m/s, and it achieves
                        this speed from a hover in 5 s. The drone has a 0.80 drag coefficient, a 0.40 m2 frontal
                        area, a 1.225 kg/m3 air density, and a 9.81 m/s2 gravitational acceleration.
                    </p>
                    <p>
                     The outbound journey is exacerbated by a steady 4 m/s crosswind and a +1 m/s wind
                    gust, but everything else is normal. The inbound journey has a 2 m/s headwind and a -1
                    m/s wind gust. The only tilt is to balance the aerodynamic drags during the cruise,
                    maintain a steady height during horizontal motion, and there are no other losses
                    besides those over and above the drags and thrust needed.
                    </p>
                    <p>
                      The task is to determine, for each mission segment—hover/climb, acceleration,
                      outbound cruise, return cruise, and descent—and for each wind case :
                    </p>
                <ul style={{ marginLeft: "20px" }}>
                    <li> &#9679; The cruise tilt angle, per-rotor thrust, and total mission energy.</li>
                    <li> &#9679;  The peak power draw under the worst-case gust conditions, and compare it to a 600 W limit. If the power exceeds this limit, propose three concrete mitigation strategies.</li>
                </ul>
                  
                  <h4>
                    <b>

                      <u>MEDIUM</u>
                    </b>
                  </h4>
                  <p>
                    Ethan Hunt is researching a spherical submersible for a deep-sea infiltration. The
                    submersible, with a radius of 1.4 m and a density of 1025 kg/m3, is being tested while
                    anchored to the seafloor by a steel cable of some length. The cable can withstand 9.4 x
                    10^4 N.
                  </p>
                  
                  <p>
                    The submersible is initially stationary, but a sudden undersea current of *5.63 m/s*
                    exerts a steady drag force at an angle of 22 degrees from the horizontal. The
                    submersible's drag coefficient is 0.47, and the water density is 1030 kg/m3.
                  </p>
                  <ul style={{ marginLeft: "20px" }}>
                    <li> &#9679; Find the angle of deflection of the sphere from its initial position.</li>
                    <li> &#9679; Find the magnitude of force which will drive this deflection.</li>
                    <li> &#9679; Find out if the cable will break or not.</li>

                  </ul>

                  <h4>
                    <b>
                      <u>HARD</u>
                    </b>
                  </h4>
                  <p>
                    In the backyard of their suburban home, Yash and Anup are working on their latest
                    invention, a spherical drone. In a fault scenario, it could fall directly onto a critical
                    component protected by a specialized pedestal.
                  </p>
                    <p>The drone is a solid sphere of a known radius. Its density is not uniform; it increases
                        linearly from zero at its exact center to a maximum value at its surface. During this test
                        failure, the drone is observed to be falling. At the moment it first makes contact with the
                        pedestal, it is moving at a known downward speed.
                    </p>
                    <p>
                        The drone lands on a "Parabolic Damper," which has a known initial height and a known
                        circular base radius. The damper is a solid of revolution, generated by rotating a
                        parabola about its central vertical axis.
                    </p>
                    <p>
                        The damper is made of a proprietary composite with a two-stage compression behavior:
                    </p>
                    <ul style={{ marginLeft: "20px" }}>
                      <li> &#9679; <strong>Stage 1:</strong> For applied forces up to a certain threshold force, the material behaves softly. In this stage, the reduction in its volume is directly proportional to the applied force.</li>
                      <li> &#9679; <strong>Stage 2:</strong> If the applied force exceeds this threshold, the composite hardens. The totalvolume reduction is then calculated as the volume reduction at the threshold force,plus an additional volume reduction for the force exceeding the threshold. This
                        additional reduction is also directly proportional to the excess force, but with a
                        different, smaller proportionality constant.</li>
                    </ul>
                    <p>
                        Derive a system of equations that would allow you to solve for the maximum
                        compression distance the Parabolic Damper experiences during the impact event. Your
                        derivation must start from first principles. You must clearly define all variables,
                        constants, and any key modelling assumptions you make.
                    </p>


                  <h2 className="">
                    <strong>Design</strong>
                  </h2>
                  <h4>
                    <b>
                      <u>EASY</u>
                    </b>
                  </h4>
                  <p>Preet , a mechanical engineering prodigy from MIT Manipal, returned to his village after many years. On the way, he had to cross a bridge that connects his village to nearby settlements. The bridge was badly sagged, twisted, and in such poor condition that it could collapse at any moment.</p>
                  <p>Determined to help, Preet decided to take on the challenge of designing a new bridge. The bridge must safely support at least 20 people at a time and withstand crowding at any point along its span without excessive sagging or instability.</p>
                  <p>Your task is to design the geometry of the bridge, explain your design choices, and provide a rough sketch that illustrates your proposed structure.</p>
                  
                  <h4>
                    <b>
                      <u>MEDIUM</u>
                    </b>
                  </h4>
                  <p>
                    Our latest drone model, the “IRIS” has a critical design requirement: in the event of a crash, the battery mount must be able to protect the battery from impact. This design protects the expensive carbon fiber frame and sensitive onboard electronics from the impact forces transferred by the heavy battery.
                  </p>
                  <p>Your task is to design this battery mounting system. The goal is not just to create a functional part, but to develop a well-reasoned design solution that balances conflicting requirements.</p>
                 
                  <h4>
                    <b>
                      <u>HARD</u>
                    </b>
                  </h4>
                  <p>
                    Design a recovery system for a fixed wing UAV which automatically activates during an

engine failure/power loss without any electronics (all electronics may fail), pre-
programmed landing sequence, parachutes or any stored energy springs, compressed

gas) except for gravity. The design should work even if the fixed wing is upside down. The
mechanism should also be reusable without any manual repairs.
                  </p>
                  <br />

                  <hr />
                  <br />
                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    {" "}
                    Submit the design files, word docs, pictures or videos to
                    &nbsp;
                    <a href="mailto:projectmanas.mechanical@gmail.com ">
                      projectmanas.mechanical@gmail.com
                    </a>
                    .
                  </p>

                  <p>
                    <b>NOTE: </b> These questions can be either solved in a CAD
                    software (Fusion 360, Solidworks, etc.) or the idea can be
                    presented as a neat sketch explaining it in maximum details.
                    The submissions over mail need to be accompanied with the
                    following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>

                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact">
                    <p>
                      <b>Bhuvan Rayani</b>
                      <br /> +91 9111508999
                      <br />
                    </p>
                    <p>
                      <b>Anup Kamath</b>
                      <br /> +91 9560526170
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>  
    );
}